import {
  ArrowCircleUpIcon,
  BeakerIcon,
  ColorSwatchIcon,
  HomeIcon,
  LightningBoltIcon,
  LockClosedIcon,
  PuzzleIcon,
  SupportIcon,
  TemplateIcon,
  TerminalIcon,
  UserGroupIcon,
  UserIcon,
  CalculatorIcon,
  CloudIcon,
  BookOpenIcon,
  LightBulbIcon
} from '@heroicons/react/solid';

import {
  RectangleGroupIcon,
  WrenchScrewdriverIcon,
  FaceSmileIcon
} from 'heroicons-v2/20/solid';
import { NextjsIcon } from '../icons/nextjs-icon';
import {
  ElysiaIcon,
  GatsbyIcon,
  GoIcon,
  JSIcon,
  NodeIcon,
  ReactIcon,
  RemixIcon,
  RequestAuthIcon,
  RocketIcon,
  RubyIcon,
  RustIcon,
  SignInIcon,
  SvelteIcon,
  VueIcon,
  HonoIcon,
  RedwoodIcon,
  CSharpIcon,
  ClerkIcon,
  AstroIcon
} from '@components/common/icons';

// TODO: dynamically import icons for perf?
export const ICON_MAP = {
  home: HomeIcon,
  nextjs: NextjsIcon,
  'lightning-bolt': LightningBoltIcon,
  'sign-in': SignInIcon,
  'request-authentication': RequestAuthIcon,
  user: UserIcon,
  'user-group': UserGroupIcon,
  terminal: TerminalIcon,
  template: TemplateIcon,
  puzzle: PuzzleIcon,
  rocket: RocketIcon,
  'lock-closed': LockClosedIcon,
  support: SupportIcon,
  'arrow-circle-up': ArrowCircleUpIcon,
  beaker: BeakerIcon,
  'color-swatch': ColorSwatchIcon,
  cloud: CloudIcon,
  'rectangle-group': RectangleGroupIcon,
  'wrench-screwdriver': WrenchScrewdriverIcon,
  calculator: CalculatorIcon,
  community: FaceSmileIcon,
  'book-open': BookOpenIcon,
  gatsby: GatsbyIcon,
  ruby: RubyIcon,
  go: GoIcon,
  remix: RemixIcon,
  nodejs: NodeIcon,
  react: ReactIcon,
  javascript: JSIcon,
  vue: VueIcon,
  svelte: SvelteIcon,
  elysia: ElysiaIcon,
  rust: RustIcon,
  hono: HonoIcon,
  redwood: RedwoodIcon,
  csharp: CSharpIcon,
  lightbulb: LightBulbIcon,
  clerk: ClerkIcon,
  astro: AstroIcon,
};
